import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { deleteCustomLookupTables } from '../utils/urls';

import { ErrorModal } from 'types/modalTypes';

async function deleteCustomTables({
  accountId,
  tableId,
  removeIfAssociationWithDeletedQuestion,
}: TVariables): Promise<TResult> {
  const response = await fetch(
    deleteCustomLookupTables(
      accountId,
      tableId,
      removeIfAssociationWithDeletedQuestion,
    ),
    {
      method: 'DELETE',
      headers: {
        Authorization: getTokenWithType(),
        'Content-Type': 'application/json',
      },
    },
  );
  return response.json();
}
type TError = ErrorModal;

type TResult = {
  Data: any;
  IsSuccess: boolean;
  StatusCode: number;
};

type TVariables = {
  accountId: number;
  tableId: string;
  removeIfAssociationWithDeletedQuestion?: boolean;
};

type TSnapshot = unknown;

function useDeleteCustomTable(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  const queryClient = useQueryClient();
  return useMutation(async (params: TVariables) => {
    const { tableId, accountId, removeIfAssociationWithDeletedQuestion } =
      params;
    const response = await deleteCustomTables({
      tableId,
      accountId,
      removeIfAssociationWithDeletedQuestion,
    });
    if (response.StatusCode === 200) {
      queryClient.invalidateQueries('get_custom_table');
    } else throw response;
    return response;
  });
}

export { useDeleteCustomTable };
